import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppPushAsideContentComponent } from './app-push-aside-content.component';
import { AsideContentComponent } from './aside-content/aside-content.component';
import { MainContentComponent } from './main-content/main-content.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ AppPushAsideContentComponent, AsideContentComponent, MainContentComponent ],
  exports: [ AppPushAsideContentComponent, AsideContentComponent, MainContentComponent ]
})
export class AppPushAsideContentModule { }
